import { CHINA_COUNTRIES, DEFAULT_LANGUAGE, RTL_COUNTRIES, SUPPORTED_LANGUAGES } from './constants'
import { isVisibleOnScreen } from './helpers.js'
import Vue, { nextTick } from 'vue'
import { onedoc } from './one-doc.js'
import { AsYouType } from 'libphonenumber-js/mobile'

export const mixin = {
  data: function () {
    return {
      langConfigLoaded: false,
      languages: {}
    }
  },
  mounted: async function () {
    await import('./languages.json')
      .then(async ({ default: json }) => {
        this.languages = json
        this.langConfigLoaded = true
        await nextTick()
      })
  },
  methods: {
    /**
     * checks if OneDoC was loaded after 10s and if not sets oneDocCompleted to true to continue with the flow
     */
    checkOneDocLoaded: function () {
      setTimeout(function () {
        if ($('#oneDocLoaded').val() === 'false') {
          $('#oneDocCompleted').val('true')
        }
      }, this.$store.state.oneDocConfig.spaRequestTimeout)
    },
    checkOneDocCompleted: function (resp) {
      const _this = this
      setTimeout(function (param) {
        if ($('#oneDocCompleted').val() === 'false') {
          _this.checkOneDocCompleted(param)
        } else {
          $('#oneDocCompleted').val('false')
          return _this.resumeToPF(param.token)
        }
      }, 100, resp)
    },
    /**
     * handles the AJAX responses involving routing
     * @param resp the received response object
     * @returns {boolean} false if the received result is unknown
     */
    handleRoutingResponse: function (resp) {
      if (!resp) return false

      this.updateStore(resp)

      if (resp.result && resp.result.startsWith('GOTO')) {
        console.debug(`routing to ${resp.result}...`)
        if (this.$router.history && this.$router.history.current && this.$router.history.current.name === resp.result) {
          window.location.reload()
        } else {
          this.$router.push({
            name: resp.result,
            params: resp
          })
        }
        return true
      } else {
        if (resp.result === 'RESUME2OIDCP') {
          if (this.$store.state.oneDocConfig.spaActive && this.$store.state.oneDocConfig.spaCountries.includes(this.$store.state.country)) {
            console.log(onedoc.getVersion())
            const iFrameElement = document.getElementById('oneDoCSpa')
            const customerDataJson = { ciam: resp.uid, ea: this.$store.state.username.includes('@') ? this.$store.state.username : '', pnf: resp.firstName, pnl: resp.lastName, tn: resp.mobile, l: resp.preferredLanguage, le: this.$store.state.oneDocConfig.spaLegalEntity, loc: this.$store.state.oneDocConfig.spaLocation, m: this.$store.state.country, s: this.$store.state.oneDocConfig.spaSystem, theme: this.$store.state.oneDocConfig.spaTheme, vari: this.$store.state.oneDocConfig.spaVariant, ds: this.$store.state.oneDocConfig.spaShowAlways ? '0' : '1' }
            iFrameElement.contentWindow.postMessage('spaCustomerDataMessage(' + JSON.stringify(customerDataJson) + ')', '*')
            this.checkOneDocCompleted(resp)
            this.checkOneDocLoaded()
            return
          } else {
            return this.resumeToPF(resp.token)
          }
        }
        if (resp.result === 'RESUME2APP') {
          return this.resumeToApp(resp.redirect)
        }
      }

      console.debug('no routing detected')
      return false
    },
    updateStore: function (resp) {
      if (resp && resp.lang) {
        this.$store.commit('lang', { lang: resp.lang, i18n: this.$i18n })
      }

      if (resp && resp.country) {
        this.$store.commit('country', resp.country)
      }

      if (resp && resp.uid) {
        this.$store.commit('uid', resp.uid)
      }

      if (resp && resp.username) {
        this.$store.commit('username', resp.username)
      }
      if (resp && resp.unconfirmedUsername) {
        this.$store.commit('unconfirmedUsername', resp.unconfirmedUsername)
      }
    },
    resumeToPF: function (token) {
      this.submitRequest(this.$store.state.urlPF + this.$store.state.resume, { token: token })
    },

    resumeToApp: function (redirect) {
      window.location.replace(redirect)
    },

    /**
     * renders the errors received from AJAX calls
     * @param resp
     */
    onAjaxError: function (resp) {
      if (resp) {
        const _this = this

        if (resp.errors) {
          const messages = []
          resp.errors.forEach(function (msg) {
            if (msg.params) {
              msg.params.forEach(function (param, index) {
                var translatedParam = [_this.$t(param)]
                msg.params[index] = translatedParam
              })
            }
            messages.push(_this.$t(msg.key, msg.params))
          })

          $('.ui.form').form('add errors', messages)
          if (!isVisibleOnScreen($('.ui.error.message')[0])) {
            $('.ui.error.message')[0].scrollIntoView(true)
          }
        }

        if (resp.prompts) {
          resp.prompts.forEach(function (msg) {
            const message = _this.$t(msg.key, msg.params)
            $('.ui.form').form('add prompt', msg.fieldId, message)
          })
        }
      } else {
        console.error(resp)
      }
    },

    /**
     * sends a request to the specified url from a form. this will change the window location.
     * @param {string} path the path to send the post request to
     * @param {object} params the paramiters to add to the url
     * @param {string} [method=post] the method to use on the form
     */
    submitRequest: function (path, params, method) {
      method = method || 'post' // Set method to post by default if not specified.

      // The rest of this code assumes you are not using a library.
      // It can be made less wordy if you use one.
      const form = document.createElement('form')
      form.setAttribute('method', method)
      form.setAttribute('action', path)

      for (const key in params) {
        if (params[key]) {
          const hiddenField = document.createElement('input')
          hiddenField.setAttribute('type', 'hidden')
          hiddenField.setAttribute('name', key)
          hiddenField.setAttribute('value', params[key])

          form.appendChild(hiddenField)
        }
      }

      document.body.appendChild(form)
      form.submit()
    },
    /**
     * @return a map containing the translations of the languages
     */
    $tLanguages: function (country) {
      let countryLangs
      if (this.languages && this.languages[country]) {
        countryLangs = this.languages[this.country].reduce((a, v) => ({ ...a, [v]: this.$t('common.lang.' + v) }), undefined)
      }

      if (!countryLangs) {
        countryLangs = this.$t('common.lang.' + this.$store.state.lang ? this.$store.state.lang : DEFAULT_LANGUAGE)
      }

      return countryLangs
    },
    /** creates a map containing the translated countries */
    $tCountries: function (hideChinaCountries) {
      let countryTranslations = this.$t('common.country')

      if (hideChinaCountries === true) {
        CHINA_COUNTRIES.forEach(function (cnCountry) {
          delete countryTranslations[cnCountry]
        })
      }
      if (countryTranslations) {
        countryTranslations = Object.entries(countryTranslations)
          .sort(([, a], [, b]) => a.localeCompare(b))
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
      }

      return countryTranslations
    },
    /**
     * (branded) translation
     * Example:
     * - 'page.login.header' (normal translation)
     * - 'brand.mme.page.login.header' (mme branded translation, will be shown if the brand is mme)
     * @param labelKey key to translate
     * @param params the parameters of the translation
     * @return the branded translation if exists or defaults to the non-branded
     */
    $tb: function (labelKey, params) {
      const safeBrand = this.$store.state.brand || 'mme'
      const key = 'brand.' + safeBrand + '.' + labelKey
      return this.$te(key) || this.$te(key, DEFAULT_LANGUAGE) ? this.$t(key, params) : this.$t(labelKey, params)
    },
    /** computes html escape of a string */
    escapeHtml: function (unsafe) {
      if (unsafe === null) return ''
      return unsafe
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
    },
    isMobile: function () {
      return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))
    },
    isMsEdge: function () {
      return (/Edge|trident/i.test(navigator.userAgent.toLowerCase()))
    },
    supportAcr: function (acr) {
      return this.$store.state.acr.includes(acr)
    },
    sanitizeMobile: function (username) {
      if (username !== null && username.length >= 5 && username.length <= 40 && new RegExp('^(\\+|00)[(),.\\s\\d-/]+$').exec(username) !== null) {
        if (username.startsWith('00')) {
          username = '+' + username.substring(2, username.length)
        }
      }

      return username
    },
    isMFA: function () {
      return this.$store.state.acr.includes('MFA')
    },
    isPasswordMandatory: function () {
      return this.$store.state.acr.includes('MFA') || this.$store.state.acr.includes('PASSWORD') || this.$store.state.isPasswordAndEmailEnforced
    },
    areCookiesActive: function () {
      return navigator.cookieEnabled
    },
    isRTLCountry (country) {
      return RTL_COUNTRIES.includes(country)
    },
    isNotEmpty: function (x) {
      return x != null && x.length > 0
    },
    goBack: function () {
      window.history.length > 1 ? window.history.back() : this.$router.push('/')
    },
    sanitizeUsername: function (username, useMobile) {
      username = username.replace(/\s/g, '')

      if (useMobile) {
        const ayt = new AsYouType()
        ayt.input(username)
        const cc = ayt.getCallingCode()
        username = username.replace('+' + cc + '0', '+' + cc)
      }
      return username
    },
    getTouchpointCountry: function (defaultTouchpoint) {
      if (!defaultTouchpoint) {
        defaultTouchpoint = 'DE'
      }

      return this.$store.state.touchpoint ? this.$store.state.touchpoint : defaultTouchpoint
    },
    getInitialCountry: function () {
      const storeCountry = this.$store.state.country
      const storeTouchpoint = this.$store.state.touchpoint

      if (storeCountry) return storeCountry
      if (storeTouchpoint) return storeTouchpoint

      return 'DE'
    },
    isEmail: function (value) {
      if (value == null || value === '') return false

      return value.indexOf('@') > -1
    },
    focusFirstErrorField: function (setShowErrorMethod) {
      Vue.nextTick(function () {
        setShowErrorMethod(true)
        Vue.nextTick(function () {
          const firstInvalidField = $('*[aria-invalid=true]')
          if (firstInvalidField != null && firstInvalidField.length > 0) {
            firstInvalidField[0].focus()
          }
        })
      })
    },
    isSupportedLanguage (language) {
      return SUPPORTED_LANGUAGES.includes(language)
    },
    getLanguageValue: function (language) {
      // Check if language delivered from backend is available in translations, if not use two char code
      // e.g. de-DE uses de for its translations
      let resolvedLang = language
      if (!this.isSupportedLanguage(language)) {
        resolvedLang = language.split('_')[0]
      }
      console.debug(`Resolved language [value=${resolvedLang}]`)
      return resolvedLang
    }
  }
}
// module.exports = mixin
